import type { ReactNode } from 'react';
import { memo } from 'react';

// anything except `any` is not extended
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type ComponentType = (props: any) => ReactNode;

export type GenericMemo = <T extends ComponentType>(
  component: T,
  propsAreEqual?: (prevProps: Parameters<T>[0], nextProps: Parameters<T>[0]) => boolean,
) => T;

export const memoGeneric = memo as unknown as GenericMemo;
